import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import moment from 'moment';
import ptBR from 'date-fns/locale/pt-BR';
registerLocale('pt-BR', ptBR);

class FinishBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      positionX: 0,
      positionY: 0,
      flowboard: "",
      finishBlock: "",
      startDate: new Date(),
      dateValue: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss") + '.000Z',
      tooltipIsOpen: false
    }

    this.handleDateChange = this.handleDateChange.bind(this);
  }

  handleDateChange = (date) => {
    const value = moment(date).format("YYYY-MM-DDTHH:mm:ss") + '.000Z';
    this.setState({startDate: date, dateValue: value});
  }

  render() {
    const { tooltipIsOpen } = this.state;

    return(
      <div className="block finish-block finish-block-component">
        <input type="hidden" name="finish-type" id="finish-type" defaultValue="finish"/>

        <div className="custom-tooltip">
          <a href="#" className={`custom-tooltip-link ${tooltipIsOpen ? 'active' : ''}`} onClick={() => tooltipIsOpen ? this.setState({tooltipIsOpen: false}) : this.setState({tooltipIsOpen: true})}>
            <span>?</span>
            
            <div className="custom-tooltip-card">
              <p>Defina em qual momento a campanha será finalizada. Exemplo: após mudar a situação definida no Gatilho ou finalizar em uma data específica.</p>
            </div>
          </a>
        </div>

        <p className="block-title">Finalização</p>
        <div className="select-group">
          <select name="finish-filter" id="finish-filter" className="form-control" required disabled={this.state.viewMode} defaultValue="stop_momentum">
            <option value="0" disabled>Selecione uma opção</option>
            <option value="stop_momentum" selected>Finalizar por data</option>
          </select>
        </div>
        <br/>

        <p className="block-title">Dia e hora:</p>
        <div className="select-group">
          <input type="hidden" name="finish-value" id="finish-value" value={this.state.dateValue}/>
          <DatePicker
            className="basic-input basic-date-input"
            selected={this.state.startDate}
            defaultValue={this.state.startDate}
            onChange={this.handleDateChange}
            minDate={this.state.startDate}
            showTimeSelect
            placeholder="Defina a data de hora da finalização"
            timeFormat="HH:mm"
            timeIntervals={15}
            timeCaption="Hora"
            dateFormat="dd/MM/yyyy - HH:mm"
            popperPlacement="bottom"
            disabled={this.props.viewMode}
            popperModifiers={{
              flip: {behavior: ["bottom"]},
              offset: {enabled: false, offset: '20px, 5px'},
              preventOverflow: {enabled: false},
              hide: {enabled: false}
            }}
          />
        </div>
      </div>
    )
  }
}

export { FinishBlock as Finish };